import DeviceManager from '../utils/device-manager';

const HomepagePush = {
    $containers: null,
    initialized: false,

    init() {
        const that = this;

        this.$containers = document.querySelectorAll('.js-homepage-pushs');

        DeviceManager.addCallback(attr => {
            if (!that.initialized && DeviceManager.isGreaterThan(attr.current, 'lg')) {
                that.enableEvents();
            } else if (that.initialized && !DeviceManager.isGreaterThan(attr.current, 'lg')) {
                that.disableEvents();
            }
        });
    },

    onMouseEnter(e) {
        e.target.classList.add('active');
        e.target.parentElement.parentElement.classList.add('has-active');
    },

    onMouseLeave(e) {
        e.target.classList.remove('active');
        e.target.parentElement.parentElement.classList.remove('has-active');
    },

    enableEvents() {
        this.initialized = true;

        this.$containers.forEach($container => {
            const $items = $container.querySelectorAll('.js-homepage-push');
    
            $items.forEach($item => {
                $item.addEventListener('mouseenter', this.onMouseEnter);
                $item.addEventListener('mouseleave', this.onMouseLeave);
            });
        });
    },

    disableEvents() {
        this.initialized = false;

        this.$containers.forEach($container => {
            const $items = $container.querySelectorAll('.js-homepage-push');
    
            $items.forEach($item => {
                $item.removeEventListener('mouseenter', this.onMouseEnter);
                $item.removeEventListener('mouseleave', this.onMouseLeave);
            });
        });
    }
}

export default HomepagePush;